 <div>   
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form
    #df="ngForm"
    novalidate
    class="formborder"
  >
    <div class="row m-0 col-md-12 p-0">
      <div class="col-md-3">
        <span>Select Process</span>
        <select
          name="ProcessId"
          id="ProcessId"
          [(ngModel)]="ProcessIds"
          class="form-control input-text-css"
        >
          <option value = 0>Select Process</option>
          <option *ngFor="let item of ProcessDropdown" [value]="item.ProcessId">
            {{ item.Process_Name }}
          </option>
        </select>
      </div>
      
      <div class="col-md-2">
        <button
          type="button"
          (click)="OnSearchProcessEmployee()"
          class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid"
        >
          Search
        </button>
      </div>
      
    </div>
  </form>
  <div class="table-responsive mt-3" *ngIf="DataSource">
    <mat-table
      [dataSource]="DataSource"
      matSort
      matTableExporter
      #exporter="matTableExporter"
      style="max-width: 100%; overflow: auto"
    >
      <ng-container matColumnDef="ProcessId">
        <mat-header-cell
          mat-sort-header
          class="grid-header"
          *matHeaderCellDef
          style="max-width: 50px"
          >#</mat-header-cell
        >
        <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw50">
          {{ i + 1 }}
        </mat-cell>
        
      </ng-container>

      <ng-container matColumnDef="Employee_Name">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef
          >Employee Name </mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="grid-cell">{{
          row.Employee_Name
        }}</mat-cell>
        
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    </div>
  </div>

